import { useEffect } from "react";

import * as PortalHandler from "../utilities/RomePortal";

import "../css/TicketInfo.css";

const TicketQuestionnaire = ({responses}) => {
    return <>
        <h3 className="ticket-info-page-alone-header">Ticket Questionnaire</h3>

        <div className="ticket-questionnaire-container">
            {responses.length == 0 &&
                <h2>Nothing to see here...</h2>
            }
            {responses.map((data, i) => {
                return <div className="ticket-info-column">
                    <h3>{i + 1}) {data.question}</h3>
                    <span>{data.value}</span>
                </div>
            })}
        </div>
    </>
}

export default TicketQuestionnaire;